import { useFormContext } from "react-hook-form";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useState } from "react";
interface Props {
  className?: string;
  placeholder: string;
  type: string;
  name: string;
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  regex?: RegExp;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  showEyeIcon?: boolean;
}

export default function ESInput(props: Props) {
  const {
    className,
    placeholder,
    type,
    name,
    required,
    minLength,
    maxLength,
    regex,
    showEyeIcon = false,
  } = props;

  const {
    register,
    formState: { errors },
  } = useFormContext();

  const errorMessage = errors && errors[name] && errors[name]?.message;
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const inputType =
    showEyeIcon && type === "password" && isPasswordVisible ? "text" : type;

  return (
    <>
      <div className="input-group">
        {type === "textarea" ? (
          <textarea
            className={className}
            placeholder={placeholder}
            {...register(name, {
              required: {
                value: required ?? false,
                message: `${placeholder} is required`,
              },
              minLength: {
                value: minLength ?? 0,
                message: `${placeholder} must contain atleast ${minLength} characters`,
              },
              maxLength: {
                value: maxLength ?? 500,
                message: `${placeholder} should not contain more than ${
                  maxLength ?? 500
                } characters`,
              },
              pattern: {
                value: regex ?? /.*/,
                message: `Invalid ${placeholder}`,
              },
            })}
          />
        ) : (
          <input
            className={className}
            placeholder={placeholder}
            type={inputType}
            disabled={props?.disabled}
            autoComplete="off"
            {...register(name, {
              required: {
                value: required ?? false,
                message: `${placeholder} is required`,
              },
              minLength: {
                value: minLength ?? 0,
                message: `${placeholder} must contain atleast ${minLength} characters`,
              },
              maxLength: {
                value: maxLength ?? 100,
                message: `${placeholder} should not contain more than ${maxLength} characters`,
              },
              pattern: {
                value: regex ?? /.*/,
                message: `Invalid ${placeholder}`,
              },
              
              ...(name === "NewPassword" && {
                validate: {
                  hasLowercase: (value) =>
                    /[a-z]/.test(value) || `${placeholder} must include at least one lowercase letter`,
                  hasUppercase: (value) =>
                    /[A-Z]/.test(value) || `${placeholder} must include at least one uppercase letter`,
                  hasNumeric: (value) =>
                    /\d/.test(value) || `${placeholder} must include at least one number`,
                  hasSpecialChar: (value) =>
                    /[@$!%*?&]/.test(value) || `${placeholder} must include at least one special character`,
                },
                minLength: {
                  value: 8,
                  message: `${placeholder} must contain atleast${minLength} characters`,
                },
                maxLength: {
                  value: maxLength ?? 100,
                  message: `${placeholder} should not contain more than ${maxLength} characters`,
                },
              }),
              ...(name === "password" && {
                validate: {
                  hasLowercase: (value) =>
                    /[a-z]/.test(value) || `${placeholder} must include at least one lowercase letter`,
                  hasUppercase: (value) =>
                    /[A-Z]/.test(value) || `${placeholder} must include at least one uppercase letter`,
                  hasNumeric: (value) =>
                    /\d/.test(value) || `${placeholder} must include at least one number`,
                  hasSpecialChar: (value) =>
                    /[@$!%*?&]/.test(value) || `${placeholder} must include at least one special character`,
                },
                minLength: {
                  value: 8,
                  message: `${placeholder} must contain atleast ${minLength} characters`,
                },
                maxLength: {
                  value: maxLength ?? 100,
                  message: `${placeholder} should not contain more than ${maxLength} characters`,
                },
              })
              
            })}
           
          />
        )}

        {showEyeIcon && type === "password" && (
          <span
            className="password-toggle-icon"
            style={{
              position: "absolute",
              top: "50%",
              right: "10px",
              transform: "translateY(-50%)",
              cursor: "pointer",
              zIndex: 10,
            }}
            onClick={togglePasswordVisibility}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                togglePasswordVisibility();
              }
            }}
            role="button"
            tabIndex={0}
          >
            {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
          </span>
        )}
         
      </div>
     
      {typeof errorMessage === "string" && (
        <span className="text-danger">{errorMessage}</span>
      )}
    </>
  );
}
